import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Container } from "reactstrap";
import { Spinner } from "shared/components/spinners/Spinner";
import { PageTemplate } from "shared/global-layouts/PageTemplate";
import { GenericButton } from "shared/ui-basics";
import styled from "styled-components/macro";
import { WorkspaceCard } from "../components/cards/workspace-card";
import { UserType, modes } from "@utils/optionsSets/OptionSets";
import { getSusbscriptionName } from "redux/memoizedSelectors";
import DataLoader from "shared/components/data-loader";
import { getAllWorkspaces } from "../reducer/WorkspaceActions";
import { memo } from "react";

export default function WorkspacesList() {
	const { t } = useTranslation();
	const history = useHistory();

	const userInfo = useSelector(({ auth }) => auth?.userInfo || {});
	const isSharedEnterprise = useSelector(getSusbscriptionName)?.isSubscriptionAllowed(["sharedenterprise"]);

	const { all_workspaces: workspaces } = useSelector((state) => state.workspaces);

	const userType = Number(userInfo?.UserType);
	const isCompanyAdmin = userType === UserType.companyAdmin;

	const onCreate = () => {
		history.push(`/edit-workspace?mode=${modes.create}`);
	};

	const filterWorkspaces = (workspaces) => {
		if (isCompanyAdmin) return workspaces;
		return workspaces?.filter((ws) => ws.authorizedUsers?.find((au) => au?.id === userInfo?.UserId)?.roleName === "owner");
	};

	const currentWorkspaces = filterWorkspaces(workspaces);
	const isButtonDisabled = isSharedEnterprise && currentWorkspaces?.length > 1;
	const sortStable = (list) => {
		return list.slice().sort((a, b) => {
			const nameComparison = a.name.localeCompare(b.name);
			return nameComparison !== 0 ? nameComparison : a.index - b.index;
		});
	};
	return (
		<PageTemplate classNames="container p-5" pageTitle={`${t("YOUR")} ${t("WORKSPACES")}`}>
			{isCompanyAdmin && (
				<BtnContainer>
					<GenericButton
						className="mb-5"
						variant="primary"
						icon="SQUARE_PLUS"
						iconClassName="me-1"
						onClick={onCreate}
						tooltip={isButtonDisabled}
						tooltipText={t("TWO_MAX_AVAILABLE_WORKSPACES")}
						disabled={isButtonDisabled}>
						{t("NEW_WORKSPACE")}
					</GenericButton>
				</BtnContainer>
			)}
			<DataLoader reduxActions={[getAllWorkspaces]}>
				<Cards workspaces={sortStable(currentWorkspaces)} isCompanyAdmin={isCompanyAdmin} />
			</DataLoader>
		</PageTemplate>
	);
}

const Cards = memo(({ workspaces, isCompanyAdmin }) => {

	return <Col>
		<CardContainer>
			{workspaces?.map((workspace) => (
				<div key={workspace.id} className="mb-3">
					<WorkspaceCard workspace={workspace} isCompanyAdmin={isCompanyAdmin} />
				</div>
			))}
		</CardContainer>
	</Col>;
});
Cards.displayName = "Cards";
export const CardContainer = styled(Container)`
	margin-left: 0px;
	padding-left: 0px;
`;

const BtnContainer = styled.div`
	width: fit-content;
`;
